// extracted by mini-css-extract-plugin
export var animationContainer = "_gm-0";
export var asteriskIcon = "_gm-8";
export var conversationLeftSection = "_gm-4";
export var conversationListItem = "_gm-3";
export var conversationMiddleSection = "_gm-5";
export var conversationRightSection = "_gm-6";
export var detailsContent = "_gm-1";
export var listContainer = "_gm-7";
export var modalContent = "_gm-2";